
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/venta-imagenes",
      function () {
        return require("private-next-pages/corporatiu/venta-imagenes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/venta-imagenes"])
      });
    }
  